// extracted by mini-css-extract-plugin
export default {"textLabelGroupNameSearchWrap":"GroupModalCreate_textLabelGroupNameSearchWrap__baPG9","spin":"GroupModalCreate_spin__3E21c"};